/**
Project: Voice Panel (c)
Title: User tenent Table Header Columns  
Description: Settings related to User list page table header column 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import IntlUtil from "../../../../core//helpers/intl-util";

export const UsersTenentTableHeaderColumns = (intlNamespace) => [
  {
    columnId: "name",
    columnLabel: IntlUtil.getText(intlNamespace, "content.displayName"),
    isSortable: false,
    hasTooltip: false,
    isFilter: false,
    tooltipText: null,
    cellClassName: "vpa-usn-table-header-cell max-w-150 min-w-135",
    tooltipClassName: null,
  },
  {
    columnId: "email",
    columnLabel: IntlUtil.getText(intlNamespace, "content.userName"),
    isSortable: false,
    hasTooltip: false,
    isFilter: false,
    tooltipText: null,
    cellClassName: "vpa-usn-table-header-cell max-w-150 min-w-135",
    tooltipClassName: null,
  },
  {
    columnId: "city",
    columnLabel: IntlUtil.getText(intlNamespace, "content.city"),
    isSortable: false,
    isFilter: false,
    hasTooltip: false,
    tooltipText: null,
    placeholderText: IntlUtil.getText(intlNamespace, "content.selectCity"),
    cellClassName: "vpa-usn-table-header-cell max-w-140 min-w-130",
    tooltipClassName: null,
  },
  {
    columnId: "country",
    columnLabel: IntlUtil.getText(intlNamespace, "content.country"),
    isSortable: false,
    isFilter: false,
    hasTooltip: false,
    tooltipText: null,
    placeholderText: IntlUtil.getText(intlNamespace, "content.selectCountry"),
    cellClassName: "vpa-usn-table-header-cell max-w-135 min-w-130",
    tooltipClassName: null,
  },
  {
    columnId: "phone",
    columnLabel: IntlUtil.getText(intlNamespace, "content.phoneNumber"),
    isSortable: false,
    hasTooltip: false,
    tooltipText: null,
    isFilter: false,
    placeholderText: null,
    cellClassName: "vpa-usn-table-header-cell min-w-200",
    tooltipClassName: null,
  },
  {
    columnId: "policyId",
    columnLabel: IntlUtil.getText(intlNamespace, "content.callingPolicy"),
    isSortable: false,
    isFilter: false,
    hasTooltip: true,
    tooltipText: IntlUtil.getText(
      intlNamespace,
      "content.callingPolicyTooltip"
    ),
    placeholderText: IntlUtil.getText(
      intlNamespace,
      "content.selectCallingPolicy"
    ),
    cellClassName: "vpa-usn-table-header-cell min-w-200",
    tooltipClassName: "vpa-page-tooltip",
  },
  {
    columnId: "phoneLicenseStatus",
    columnLabel: IntlUtil.getText(intlNamespace, "content.phoneLicense"),
    isSortable: false,
    hasTooltip: true,
    isFilter: false,
    tooltipText: IntlUtil.getText(intlNamespace, "content.phoneLicenseTooltip"),
    placeholderText: null,
    cellClassName: "vpa-usn-table-header-cell max-w-150 min-w-120",
    tooltipClassName: "vpa-page-tooltip",
  },
  {
    columnId: "action",
    columnLabel: null,
    isSortable: false,
    ischecked: true,
    hasTooltip: false,
    tooltipText: null,
    cellClassName: "vpa-usn-table-header-cell max-w-80",
    tooltipClassName: null,
  },
];
